import { useState } from 'react'

import { AccordionListContainer, ToggleOptionGroup, ToggleOptionGroupItem } from 'twyne-new.ui'

import Datasources from './Datasources'
import Properties from './Properties'

export default function RightSidebar() {
  const [selected, setSelected] = useState('properties')

  return <>
    <AccordionListContainer>
      <ToggleOptionGroup type='single' defaultValue={selected} size={'lg'} className='mb-2' onValueChange={setSelected}>
        <ToggleOptionGroupItem value='properties'>
          Properties
        </ToggleOptionGroupItem>
        <ToggleOptionGroupItem value='datasources'>
          Data Source
        </ToggleOptionGroupItem>
      </ToggleOptionGroup>
    </AccordionListContainer>
    <div className={selected === 'datasources' ? 'block' : 'hidden'}>
      <Datasources />
    </div>
    <div className={selected === 'properties' ? 'block' : 'hidden'}>
      <Properties />
    </div>
  </>
}
